var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltipsIconDarkGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9498 2.05023C10.6276 0.728137 8.86977 0 7 0C5.13023 0 3.37239 0.728137 2.05023 2.05023C0.728137 3.37239 0 5.13023 0 7C0 8.86977 0.728137 10.6276 2.05023 11.9498C3.37239 13.2719 5.13023 14 7 14C8.86977 14 10.6276 13.2719 11.9498 11.9498C13.2719 10.6276 14 8.86977 14 7C14 5.13023 13.2719 3.37239 11.9498 2.05023ZM7 1.91406C7.82925 1.91406 8.50391 2.58871 8.50391 3.41797C8.50391 4.24722 7.82925 4.92188 7 4.92188C6.17075 4.92188 5.49609 4.24722 5.49609 3.41797C5.49609 2.58871 6.17075 1.91406 7 1.91406ZM8.91406 11.4844H5.08594V10.6641H5.90625V6.5625H5.08594V5.74219H8.09375V10.6641H8.91406V11.4844Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipsIconDarkGrey);
export default __webpack_public_path__ + "static/media/tooltips-icon-dark-grey.b5e2f1e3d1070886c734e7e7e80643e2.svg";
export { ForwardRef as ReactComponent };